const Currency = (e) => {
  if (e === "EUR") return "€";
  else if (e === "USD") return "$";
  else if (e === "GBP") return "£";
  else if (e === "TRY") return "₺";
  else return "€";
};

export default Currency;
